import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://heartlandphysics.com";

export const usePageMeta = (title, description) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const el = document.querySelector('meta[name="description"]');
      if (el) el.setAttribute("content", description);
    }
    // Canonical always points at the production URL of THIS page
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${SITE}${pathname}`);
  }, [title, description, pathname]);
};
